import React, { useState } from 'react';
import Button from '../common/Button';
import CountdownTimer from '../common/CountdownTimer';
import FullScreenLoader from '../loader/FullScreenLoader';
import { useWallet } from '../../context/WalletContext';
import { useContractState } from '../../context/ContractContext';
import { useNotify } from '../../context/NotificationContext';
import { getADNFTContract } from '../../web3/contractInstance';
import { parseContractError } from '../../utils/errors';
import { formatUSDT } from '../../utils/format';

export default function TradingProfitCard() {
  const { getSigner } = useWallet();
  const { basic, pendingROI, investments, refresh } = useContractState();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const hasActive = investments && investments.some(i => i.active);
  const nowSec = Math.floor(Date.now() / 1000);
  const eligibleAt = basic ? Number(basic.nextTradeEligibleAt || 0) : 0;
  const ready = hasActive && eligibleAt > 0 && nowSec >= eligibleAt;

  async function fire() {
    const signer = getSigner();
    if (!signer) { notify.error('Wallet not ready'); return; }
    setBusy(true);
    try {
      const c = getADNFTContract(signer);
      const tx = await c.startTrade();
      await tx.wait();
      notify.success('Trade started', 'Trading profit credited to your balance');
      refresh();
    } catch (e) {
      notify.error('Start Trade failed', parseContractError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="trade-profit-card">
      <div className="title">Today's Trading Profit</div>
      <div className="amount">{formatUSDT(pendingROI)}</div>
      <div className="status">
        {!hasActive
          ? 'No active investments.'
          : ready
            ? 'Ready to credit trading profit now.'
            : <>Next eligible in <span className="countdown"><CountdownTimer targetTs={eligibleAt} /></span></>}
      </div>
      <Button neon block size="lg" onClick={fire} loading={busy} disabled={!ready}>
        {ready ? '⚡ Start Trade' : 'Not Ready Yet'}
      </Button>
      {busy && <FullScreenLoader message="Starting trade…" sub="Confirm in your wallet" />}
    </div>
  );
}
